import { FC } from "react";
import styles from "./SingleModuleAppLogo.module.css";
import LogoRothoblaas from "./ui/LogoRothoblaas";

type SingleModuleAppLogoProps = {
  title: string;
};

const SingleModuleAppLogo: FC<SingleModuleAppLogoProps> = ({ title }) => (
  <div className={styles.logo}>
    <LogoRothoblaas /> {title}
  </div>
);

export default SingleModuleAppLogo;
